import { observer } from 'mobx-react-lite';

import { FileField as CoreFileField, FileFieldMulti } from '@components/file-field';
import { Select } from '@components/select';
import { SelectMulti } from '@components/selectmulti';
import { TextField } from '@components/text-field';
import { TextArea } from '@components/textarea';

import { useStore } from 'models/stores';
import { toSelectedMap } from 'shared/utils/select';

export default observer(({ question, disabled }) => {
  const {
    uiStore: { t },
  } = useStore();
  const error = question.error ? t(question.error) : '';
  const label = question.required ? `${question.title} *` : question.title;

  if (question.type === 'one_line') {
    return (
      <TextField
        label={label}
        value={question.value || ''}
        onChange={(value) => question.setValue(value)}
        error={error}
        isDisabled={disabled}
        isFullWidth
      />
    );
  }

  if (question.type === 'multi_line') {
    return (
      <TextArea
        label={label}
        value={question.value || ''}
        onChange={(value) => question.setValue(value)}
        error={error}
        isDisabled={disabled}
      />
    );
  }

  if (question.type === 'dropdown') {
    return (
      <Select
        label={label}
        placeholder={t('select_placeholder')}
        options={(question.options || []).map((o) => ({ label: o.display, value: o.value }))}
        value={question.value || ''}
        onChange={(value) => question.setValue(value)}
        error={error}
        isDisabled={disabled}
      />
    );
  }

  if (question.type === 'multidropdown') {
    const options = (question.options || []).map((o) => ({ label: o.display, value: o.value }));
    const selectedValues = question.value || [];
    return (
      <SelectMulti
        label={label}
        placeholder={t('select_placeholder')}
        options={options}
        value={options.filter((o) => selectedValues.includes(o.value))}
        onChange={(selected) => question.setValue(toSelectedMap(selected))}
        error={error}
        isDisabled={disabled}
      />
    );
  }

  if (question.type === 'attachment' && !question.multiple) {
    return (
      <CoreFileField
        label={label}
        placeholder={t('upload_file')}
        defaultValue={question.value || undefined}
        onChange={(file) => question.setValue(file)}
        error={error}
        isDisabled={disabled}
      />
    );
  }

  if (question.type === 'attachment' && question.multiple) {
    return (
      <FileFieldMulti
        label={label}
        placeholder={t('upload_file')}
        onChange={(files) => question.setFiles(files)}
        error={error}
        isDisabled={disabled}
      />
    );
  }

  return null;
});
